import { useEffect, useState } from "react";
import { calculateWireItemFee } from "../../api/NetworkingFees";
import { getResource } from "../../helpers/ResourcesHelper";
import Button from "../inputs/Button";
import { Disbursement } from "../models/Disbursement";
import { DisbursementItem } from "./DisbursementItem";
import { usePaymentTransactionContext } from "./PaymentTransactionContext";

const DisbursementsForm = () => {

  const { buyCurrency, sellCurrency, lockedSide, settlementMethod, disbursements, setDisbursements,
    setTotalPayment, setTotalSettlement, setTotalFees, customerRate, disbursementInfoAsParameter } = usePaymentTransactionContext();

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const loadFees = async (disbursement: Disbursement) => {
      let customerId = JSON.parse(localStorage.getItem('UserSession')!).CustomerID
      let feeJson = await calculateWireItemFee(customerId, sellCurrency, buyCurrency, disbursement.amount, customerRate, settlementMethod, disbursement.instrument || '')
      console.log('fee ', feeJson)
      if (feeJson.httpStatusCode === 200) {
        disbursement.fee = feeJson.FeeAmount
      }
    }
    if (customerRate !== 0 && Array.isArray(disbursements)) {
      disbursements.forEach(d => {
        loadFees(d)
      })
    }
  }, [buyCurrency, customerRate, sellCurrency, settlementMethod, disbursements]);

  useEffect(() => {
    if (Array.isArray(disbursements)) {
      disbursements.forEach(d => {
        d.fee = 0
        if ('buy' === lockedSide) {
          d.otherAmount = 0
        } else {
          d.amount = 0
        }
      })
    }
  }, [sellCurrency, buyCurrency, disbursements, lockedSide]);

  let Disbursements = [];
  if (Array.isArray(disbursements) && disbursements.length > 0) {
    Disbursements = disbursements.map((d: Disbursement) => { return <DisbursementItem disbursement={d} /> });
    let totalPaymentL = 0
    let totalSettlement = 0;
    let tatalFees = 0;
    if (Array.isArray(disbursements) && disbursements.length > 0) {
      totalPaymentL = disbursements.reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0)
      totalSettlement = disbursements.reduce((accumulator, currentValue) => accumulator + (currentValue.otherAmount || 0), 0)
      tatalFees = disbursements.reduce((accumulator, currentValue) => accumulator + (currentValue.fee || 0), 0)
    }
    setTotalPayment(totalPaymentL)
    setTotalSettlement(totalSettlement)
    setTotalFees(tatalFees)
  }
  else {
    Disbursements.push(<div className="row"><hr /></div>)
  }

  const addNewDisbursement = () => {
    let lineNumber;

    let disbursementList: Disbursement[]
    if (Array.isArray(disbursements)) {
      disbursementList = disbursements
      lineNumber = disbursementList.length
    } else {
      disbursementList = []
      lineNumber = 0
    }

    lineNumber++;
    disbursementList.push({
      amount: 0,
      bankAccountId: 0,
      beneficiaryId: 0,
      fee: 0,
      instrument: '',
      lineNumber: lineNumber,
      key: `${lineNumber}`,
      otherAmount: 0,
    })
    setDisbursements(disbursementList)
    setRefresh(!refresh)
  }

  return <>
    <div className="col-xs-12"></div>
    <div className="col-md-3 col-xs-12 header-hidden">
      <span>{getResource('Js_TH_Beneficiary')}</span>
    </div>
    <div className="col-md-3 col-xs-12 header-hidden">
      <span>{getResource('Label.Instrument')}</span>
    </div>
    <div className="col-md-1°5 col-xs-12 header-hidden">
      <span>{getResource('Label.WeSend')} ({buyCurrency})</span>
    </div>
    <div className="col-md-1°5 col-xs-12 header-hidden">
      <span>{getResource('Label.WePay')}  ({sellCurrency})</span>
    </div>
    <div className="col-md-1 col-xs-12 header-hidden">
      <span>{getResource('Label.Fee')} ({sellCurrency})</span>
    </div>
    <div className="col-md-1 col-xs-12 header-hidden">
      <span>{getResource('Label.Reference')}</span>
    </div>
    <div className="col-md-1 col-xs-12 header-hidden">
      <span>{getResource('Table_TH_Actions')}</span>
    </div>
    <div className="col-xs-12">
      {Disbursements}
    </div>
    <div className="col-xs-12 col-md-12"><Button onClick={addNewDisbursement} disabled={disbursementInfoAsParameter}>Add Line</Button></div>
  </>

}

export default DisbursementsForm